import React from 'react';
import { Badge } from '@/components/ui/badge';
import { CheckCircle, PieChart, Clock, AlertTriangle, XCircle, RefreshCcw } from 'lucide-react';

const MAP = {
  pago: { label: 'Pago', cls: 'bg-emerald-100 text-emerald-800 border-emerald-200', Icon: CheckCircle },
  parcial: { label: 'Parcial', cls: 'bg-violet-100 text-violet-800 border-violet-200', Icon: PieChart },
  pendente: { label: 'A vencer', cls: 'bg-amber-100 text-amber-800 border-amber-200', Icon: Clock },
  vencido: { label: 'Vencido', cls: 'bg-rose-100 text-rose-800 border-rose-200', Icon: AlertTriangle },
  cancelado: { label: 'Cancelado', cls: 'bg-slate-100 text-slate-600 border-slate-200', Icon: XCircle },
  estornado: { label: 'Estornado', cls: 'bg-slate-100 text-slate-600 border-slate-200', Icon: XCircle },
  renegociado: { label: 'Renegociado', cls: 'bg-sky-100 text-sky-800 border-sky-200', Icon: RefreshCcw },
};

export const TituloStatusBadge = ({ status }) => {
  const cfg = MAP[status] || MAP.pendente;
  const { Icon } = cfg;
  return (
    <Badge className={`gap-1 border font-semibold ${cfg.cls}`} data-testid={`status-badge-${status || 'pendente'}`}>
      <Icon className="w-3 h-3" />
      {cfg.label}
    </Badge>
  );
};

export default TituloStatusBadge;
